import React from 'react';
import { useIntl } from 'react-intl';

import { useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';
import { RSButtonLink } from 'src/reservation-page/RSButtonLink';
import { RSButtonAnchor } from 'src/reservation-page/RSButtonAnchor';
import { buildSiteUrl } from 'src/utils/request-url';

interface OwnProps {
  public_id: string;
  isBookable: boolean;
  contactUrl: string | null;
}

type CarryOverQueryWhenEnterReservationFlowKey =
  | 'selected_date'
  | 'selected_slot'
  | 'selected_lesson'
  | 'selected_course'
  | 'selected_staff';
type CarryOverQueryWhenEnterReservationFlow = {
  [key in CarryOverQueryWhenEnterReservationFlowKey]?: string;
};

type Props = OwnProps;

const MerchantCourseDetailsReservationButton: React.FC<Props> = ({
  isBookable,
  public_id,
  contactUrl,
}) => {
  const intl = useIntl();

  const router = useRouter();

  const carryOverQuery = extractCarryOverQueryFromCurrentUrl(router.query);

  const bookingFlowEnterPath = buildSiteUrl(`/${public_id}/book`);

  const contactPageHref =
    contactUrl || buildSiteUrl(`/contact?via=${public_id}`);

  return (
    <>
      {isBookable ? (
        <RSButtonLink
          isBlock
          href={{ pathname: bookingFlowEnterPath, query: carryOverQuery }}
          prefetch={false}
        >
          {intl.formatMessage({
            id: 'merchants.bookingPages.reservation',
          })}
        </RSButtonLink>
      ) : (
        <RSButtonAnchor isBlock href={contactPageHref}>
          {intl.formatMessage({
            id: 'merchants.bookingPages.inquiry',
          })}
        </RSButtonAnchor>
      )}
    </>
  );
};

const extractCarryOverQueryFromCurrentUrl = (
  query: ParsedUrlQuery,
): CarryOverQueryWhenEnterReservationFlow => {
  const extracted: CarryOverQueryWhenEnterReservationFlow = {};

  const extract = (key: keyof CarryOverQueryWhenEnterReservationFlow) => {
    const q = query[key];

    if (typeof q === 'string') {
      extracted[key] = q;
    }
  };

  extract('selected_staff');
  extract('selected_course');
  extract('selected_lesson');
  extract('selected_slot');
  extract('selected_date');

  return extracted;
};

export default MerchantCourseDetailsReservationButton;
